module.exports = __webpack_public_path__ + "static/media/SellerboxFunction05.65bbd8df.png";